/*
 * Bradford: plays the product video on product card hover (snippets/bradford-card-video.liquid).
 * - Desktop / mouse only: on touch devices nothing is requested.
 * - Lazy: the video src is only set on the first hover of that card.
 * - Delegated listeners, so cards added later (filters, predictive search, recently viewed...) also work.
 */
(() => {
  if (window.bradfordCardVideo) return;
  window.bradfordCardVideo = true;

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  const getVideo = (card) => card && card.querySelector('.bradford-card-video');

  // Liquid only gives the 1080p file; a card does not need it, so ask for the 720p rendition of the same video
  const LIGHT_RENDITION = '.HD-720p-3.0Mbps-';
  const lightSource = (url) => url.replace(/\.HD-1080p-[\d.]+Mbps-/, LIGHT_RENDITION);

  const start = (card, video) => {
    card.bradfordHover = true;

    if (!video.getAttribute('src')) {
      const light = lightSource(video.dataset.src);

      if (light !== video.dataset.src) {
        // If that rendition does not exist, go back to the original file
        video.addEventListener('error', () => {
          video.src = video.dataset.src;

          if (card.bradfordHover) {
            video.play()?.catch(() => {});
          }
        }, { once: true });
      }

      video.src = light;
    }

    const playing = video.play();

    if (playing) {
      playing.catch(() => {});
    }
  };

  const stop = (card, video) => {
    card.bradfordHover = false;
    video.classList.remove('is-playing');
    video.pause();

    if (video.readyState > 0) {
      video.currentTime = 0;
    }
  };

  // Only reveal the video once frames are actually playing, so the photo never disappears into a blank box
  document.addEventListener('playing', (event) => {
    const video = event.target;

    if (!video.classList || !video.classList.contains('bradford-card-video')) return;

    if (video.closest('product-card')?.bradfordHover) {
      video.classList.add('is-playing');
    } else {
      video.pause();
    }
  }, true);

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse' || !canHover.matches) return;

    const card = event.target.closest?.('product-card');
    const video = getVideo(card);

    if (!video || card.contains(event.relatedTarget)) return;

    start(card, video);
  });

  document.addEventListener('pointerout', (event) => {
    if (event.pointerType !== 'mouse') return;

    const card = event.target.closest?.('product-card');
    const video = getVideo(card);

    if (!video || card.contains(event.relatedTarget)) return;

    stop(card, video);
  });
})();
